import React, { useEffect, useState } from "react";
import MarsAdminTable from "./TechReviewerAdminTable";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Collapse } from "react-collapse";
import { getToken } from "../../auth/authConfig";
import axios from "axios";
import "./TechReviewerHome.scss";
import { Alert, Box } from "@mui/material";
import { login } from "../../auth/msalAuth";

const TechReviewerHome = () => {
  const [expanded, setExpanded] = useState([true, false, false, false, false]);
  const [initialFormData, setInitialFormData] = useState(null);
  const [intialFormLoading, setInitialFormLoading] = useState(false);
  const [initialFormError, setInitialFormError] = useState(false);
  const [versioningFormData, setVersioningFormData] = useState(null);
  const [completedFormData, setCompletedFormData] = useState(null);
  const [pendingforupload, setpendingforupload] = useState(null);

  const [sendBackFormData, setSendBackFormData] = useState(null);
  const [initaitedAuditForm, setinitaitedAuditForm] = useState(null);
  const [error, setError] = useState(false);

  const handleToggle = (index) => {
    setExpanded((prev) =>
      prev.map((value, i) => (i === index ? !value : value))
    );
  };

  const getFormListDetails = async () => {
    const getInitialFormURL = `${process.env.REACT_APP_SERVER_URL}/api/review/list`;
    const token = await getToken();
    setInitialFormLoading(true);
    try {
      const response = await axios.get(getInitialFormURL, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        setInitialFormData([]);
        setInitialFormLoading(false);

        const json = response.data;

        const initiatedForms = json && json.initaited_forms;
        const Completed = json && json.completd_forms;
        const sendback = json && json.sentback_forms;
        const versioning = json && json.versioned_forms;
        const initiatedAudit = json && json.only_initiated;
        const certificatePending = json && json.certificate_pending;


        setInitialFormData(initiatedForms || []);
        setCompletedFormData(Completed || []);
        setSendBackFormData(sendback || []);
        setVersioningFormData(versioning || []);
        setinitaitedAuditForm(initiatedAudit || []);
        setpendingforupload(certificatePending || [])
      } else {
        setInitialFormError("Oops! Something went wrong. . .");
        setInitialFormLoading(false);
      }
    } catch (e) {
      setInitialFormLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      setInitialFormError("Oops! Something went wrong. . .");
    }
    // finally {
    //   setInitialFormError(false);
    // }
  };

  useEffect(() => {
    getFormListDetails();
  }, []);


  return (
    <>
      <div id="mars-verification" className="mars-verification-section">
     

        <div className="mars-Audited-Forms-sections mars-verification-common">
          <div className="collapse-section">
            <h3 className="main-heading">List of Forms Needing Tech Review</h3>
            <div className="collapse-btn" onClick={() => handleToggle(0)}>
              {expanded[0] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
          </div>

          <Collapse isOpened={expanded[0]}>
            <MarsAdminTable
              loading={intialFormLoading}
              error={initialFormError}
              tableData={initialFormData || []}
              title="List of Forms Needing Verification"
              color="orange"
              expand={expanded[0]}
              view={false}
              download={false}
              colorValue="ff8200"
              buttonView="#efc599"
              buttonText="#915313"
              uploadCertification= {false}
              getFormListDetails={getFormListDetails}

            />
          </Collapse>
        </div>

        <div className="mars-Audited-BackForms-sections mars-verification-common">
          <div className="collapse-section">
            <h3 className="main-heading">List of Sent Back Forms</h3>
            <div className="collapse-btn" onClick={() => handleToggle(3)}>
              {expanded[3] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
          </div>

          <Collapse isOpened={expanded[3]}>
            <MarsAdminTable
              loading={intialFormLoading}
              error={initialFormError}
              tableData={sendBackFormData || []}
              title="List of Sent Back Forms"
              color="perple"
              expand={expanded[3]}
              view={true}
              download={false}
              colorValue="9600ff"
              buttonView="#d1b1e7"
              buttonText="#48176b"
              uploadCertification= {false}
              getFormListDetails={getFormListDetails}

            />
          </Collapse>
        </div>

        <div className="mars-AuditedVersioning-Forms-sections mars-verification-common">
          <div className="collapse-section">
            <h3 className="main-heading">List of Forms Requiring Versioning</h3>
            <div className="collapse-btn" onClick={() => handleToggle(1)}>
              {expanded[1] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
          </div>

          <Collapse isOpened={expanded[1]}>
            <MarsAdminTable
              loading={intialFormLoading}
              error={initialFormError}
              tableData={versioningFormData || []}
              title="List of Forms Requiring Versioning"
              color="red"
              expand={expanded[1]}
              view={true}
              download={true}
              colorValue="ff3c14"
              buttonView="#f1c2b8"
              buttonText="#9d3520"
              version={1}
              uploadCertification= {false}
              getFormListDetails={getFormListDetails}

            />
          </Collapse>
        </div>

      


        <div className="mars-AuditedCompleted-Forms-sections mars-verification-common">
          <div className="collapse-section">
            <h3 className="main-heading">List of Forms Needing Upload Certification </h3>
            <div className="collapse-btn" onClick={() => handleToggle(4)}>
              {expanded[4] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
          </div>

          <Collapse isOpened={expanded[4]}>
            <MarsAdminTable
              loading={intialFormLoading}
              error={initialFormError}
              tableData={pendingforupload || []}
              title="List of Forms Needing Upload Certification"
              color="blue"
              expand={expanded[4]}
              view={true}
              download={true}
              colorValue="5746ec"
              buttonView="#c5cfec"
              buttonText="#102358"
              uploadCertification= {true}
              getFormListDetails={getFormListDetails}

            />
          </Collapse>
        </div>

        <div className="mars-AuditedCompleted-Forms-sections mars-verification-common">
          <div className="collapse-section">
            <h3 className="main-heading">List of Audit Completed Forms</h3>
            <div className="collapse-btn" onClick={() => handleToggle(2)}>
              {expanded[2] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
          </div>

          <Collapse isOpened={expanded[2]}>
            <MarsAdminTable
              loading={intialFormLoading}
              error={initialFormError}
              tableData={completedFormData || []}
              title="List of Audit Completed Forms"
              color="green"
              expand={expanded[2]}
              view={true}
              download={true}
              colorValue="769711"
              buttonView="#d8e5ad"
              buttonText="#41530b"
              uploadCertification= {false}
              getFormListDetails={getFormListDetails}

            />
          </Collapse>
        </div>



      </div>
      {error && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default TechReviewerHome;
